import Vue from 'vue'
import pdf from '@teckel/vue-pdf'
Vue.component('Pdf', pdf)
